import { OptanonGPP } from 'services/OptanonGPP';

const gppPromiseTimeout = 3000;

const gppTimeOutPromise = (gppPromise, timeout) => {
    let timeoutId;

    const tiemoutPromise = new Promise((resolve, reject) => {
        timeoutId = setTimeout(() => {
            reject();
        }, timeout);
    });

    return Promise.race([gppPromise, tiemoutPromise]).finally((result) => {
        clearTimeout(timeoutId);
        return result;
    });
};

const gppPromise = new Promise((resolve) => {
    window.cbsoptanon = window.cbsoptanon || { cmd: [] };
    window.cbsoptanon.cmd.push((cmp) => {
        const gppHandler = OptanonGPP(cmp);
        gppHandler.getGPPData().then((GPPData) => resolve(GPPData));
    });
});

window.CBS.Registry.gppPromise = (() => gppTimeOutPromise(gppPromise, gppPromiseTimeout))();
